/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';


export default (themes) =>
{
  let state = new Immutable.Map();

  for (const theme of themes)
  {
    state = state.set(theme.type, theme);
  }

  return state;

}
